
// OCMS.Include.script("http://ajax.aspnetcdn.com/ajax/jquery.ui/1.9.0/jquery-ui.min.js");
// OCMS.Include.script("/js/_lib/jquery.select2-3.2.4.min.js");
// OCMS.Include.style("http://ajax.aspnetcdn.com/ajax/jquery.ui/1.9.0/themes/base/jquery-ui.css");
// OCMS.Include.style("/css/" + OCMS.GlobalVars.Brand + "/plugins/jquery.select2-3.2.4.css");
// OCMS.Include.script("/js/plugins/ru.address-validator.js", function () {
//    new AddressValidator();
// });

$.validator.addMethod(
  'vipCodeValidation',
  (value, element) => {
    const newValue = $.trim((value || ''));
    if (element.hasClass('required') === true && (newValue === undefined || newValue === null || newValue === '')) {
      return false;
    }

    const lengths = {
      occ: { 9: true, 10: true, 16: true },
      mel: { 16: true }
    };
    const l = lengths[OCMS.GlobalVars.Brand];
    return l !== null && l !== undefined && l[newValue.length] === true;
  }
);



// WEBPACK FOOTER //
// ./js/countryForm/russia.form.js